<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.notificationHub.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.notificationHub.YOU_CAN"></p>
      <div>
        <ul class="td-wb-ul td-wb-ul--basic td-wb-modal-notificiation__list">
          <li translate="tdWb.modalNotification.notificationHub.DETAILS_I"></li>
          <li translate="tdWb.modalNotification.notificationHub.DETAILS_II"></li>
          <li translate="tdWb.modalNotification.notificationHub.DETAILS_III"></li>
        </ul>
      </div>
      <a class="td-wb-modal-notification__link"
         tdWbHref="link_preferences_notification_hub"
         tdWbHrefTaggingEvent="whats new:manage notifications"
         translate="tdWb.modalNotification.notificationHub.MANAGE_NOTIFICATIONS"></a>
    </div>
    <div class="td-wb-modal-notification--image-container">
      <img tdWbModalNotificationImage
           width="180px"
           height="180px"
           src="notification-hub.svg"
           [attr.alt]="'tdWb.modalNotification.notificationHub.IMAGE_ALT' | translate" />
    </div>
  </div>
</div>
